import { render, staticRenderFns } from "./AdminMarketerData.vue?vue&type=template&id=1469171c&"
import script from "./AdminMarketerData.vue?vue&type=script&lang=js&"
export * from "./AdminMarketerData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports